export default __webpack_public_path__ + "static/media/shapeRight.27dc0c07.svg";